import * as Yup from 'yup';
import { REQUIRED_ERROR_MSG } from 'utils/constants/errors';

export const setPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required(REQUIRED_ERROR_MSG)
    .min(6, 'Password is too short - should be 6 chars minimum.'),
  confirmPassword: Yup.string()
    .required()
    .test('passwords-match', 'Passwords must match', function(value) {
      return this.parent.password === value;
    })
});
